
<div class="row no-gutters">
  <ng-container *ngIf="header !== undefined">
    <div class="col-xs-12">
      <div class="row no-gutters aimsHeader">
        <div class="col-xs-12">
          <div class="aimsFormHeader">
            {{header}}
            <span *ngIf="hider" (click)="showContent = !showContent" style="cursor:pointer;padding-left:5px">
              <span *ngIf="showContent">
                <span class="fas fa-eye"></span>
              </span>
              <span *ngIf="!showContent">
                <span class="fas fa-eye-slash" *ngIf="!showContent"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-content *ngIf="showContent"></ng-content>
</div>
